import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
// 一時措置 (#4669): パートナー配車板の本開放時に削除する
import { canPartnerSeeDispatchBoard } from '@/features/vehicle-dispatch-boards/utils'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/vehicle-dispatch-boards'
)({
  beforeLoad: ({ context: { auth } }) => {
    // パートナーユーザーへの配車板開放は検証環境限定の一時措置 (#4669)。
    // 本開放時は beforeLoad ごと削除する（パートナーも無条件で閲覧可にする）
    if (auth.user.type === USER_TYPE.PARTNER && !canPartnerSeeDispatchBoard()) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  meta: () => [
    {
      title: MENU.VEHICLE_DISPATCH_BOARD
    }
  ],
  staticData: {
    stickyHeader: true
  }
})
